import * as React from 'react';
import * as fp from 'lodash/fp';

import './WhatsMyTireSize.scss';
import Popover from 'modules/cars/rating/tires/components/utils/Popover';
import TireSizePopup from 'modules/cars/rating/tires/views/TireSizePopup';

const DEFAULT_TITLE = 'Determining correct tire size';

const WhatsMyTireSize: any = ({onHide = fp.noop, isOpen = false, onClick = fp.noop, align, title = DEFAULT_TITLE}) => (
    <div className="cr-rating__whats-my-tire-size">
        <Popover isOpen={isOpen} align={align} content={<TireSizePopup title={title} onHide={onHide}/>}>
            <div className="crux-body-copy crux-body-copy--extra-small">
                <a href="javascript:void(0);" onClick={onClick} className="cr-rating__whats-my-tire-size__text">
                    What's my car's tire size?
                </a>
            </div>
        </Popover>
    </div>
);

export default WhatsMyTireSize;



// WEBPACK FOOTER //
// ./resources/modules/cars/rating/tires/views/WhatsMyTireSize.tsx